import { Link as RouterLink } from "react-router";

import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { Box, Button, IconButton, Stack } from "@mui/material";
import { EllipsisText } from "@shared";

import { DutyScheduleDetailResponse } from "@/api";
import { AppRoutes } from "@/router/AppRoutes";
import { useTranslation } from "@/translations";

interface Props {
  dutySchedule: DutyScheduleDetailResponse;
  isEditable: boolean;
  isSaving: boolean;
  isReleasing: boolean;
  isDeleting: boolean;
  onDelete: () => void;
  onEdit: () => void;
  onRelease: () => void;
}

export function DutyScheduleDetailHeader({
  dutySchedule,
  isEditable,
  isSaving,
  isReleasing,
  isDeleting,
  onDelete,
  onEdit,
  onRelease,
}: Props) {
  const { t } = useTranslation();

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" gap={2} flexWrap="wrap">
      <Stack direction="row" alignItems="center" gap={1} minWidth={0} flex={1}>
        <IconButton component={RouterLink} to={AppRoutes.DutySchedule} aria-label={t("dutySchedule.detail.backToList")}>
          <ArrowBackRoundedIcon />
        </IconButton>
        <Box minWidth={0} flex={1}>
          <EllipsisText value={dutySchedule.name} variant="h1" />
        </Box>
      </Stack>
      <Stack direction="row" gap={1} flexWrap="wrap">
        {isEditable && (
          <Button variant="outlined" color="error" disabled={isDeleting || isReleasing} onClick={onDelete}>
            {t("dutySchedule.menu.delete")}
          </Button>
        )}
        {isEditable && (
          <Button variant="outlined" onClick={onEdit}>
            {t("dutySchedule.detail.edit")}
          </Button>
        )}
        {isEditable && (
          <Button variant="contained" disabled={isSaving || isReleasing || isDeleting} onClick={onRelease}>
            {t("dutySchedule.menu.release")}
          </Button>
        )}
      </Stack>
    </Box>
  );
}
